<template>
  <async-btn
    :task="task"
    icon="fa fa-refresh"
    label="Regenerate"
    rounded
    flat
    v-bind="$attrs"
    @click="regenerate"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { regenerateApiKey } from '.';

interface Data {
  task: Promise<string>|null,
}

export default defineComponent({
  emits: ['regenerated'],
  components: { AsyncBtn },
  props: {
    serviceAccountId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    regenerate(): void {
      this.task = regenerateApiKey(this.serviceAccountId);
      this.task.then((apiKey) => {
        this.$emit('regenerated', apiKey);
      });
    },
  },
});
</script>
